import {
  CREATE_PATTERN_REQUEST,
  CREATE_PATTERN_SUCCESS,
  CREATE_PATTERN_FAIL,
  CREATE_PATTERN_RESET,
  GET_ALL_PATTERNS_REQUEST,
  GET_ALL_PATTERNS_SUCCESS,
  GET_ALL_PATTERNS_FAIL,
  GET_PATTERN_REQUEST,
  GET_PATTERN_SUCCESS,
  GET_PATTERN_FAIL,
  GET_USERS_PATTERNS_REQUEST,
  GET_USERS_PATTERNS_SUCCESS,
  GET_USERS_PATTERNS_FAIL,
  REMOVE_PATTERN_FAIL,
  REMOVE_PATTERN_REQUEST,
  REMOVE_PATTERN_SUCCESS,
  UPDATE_PATTERN_REQUEST,
  UPDATE_PATTERN_SUCCESS,
  UPDATE_PATTERN_FAIL,
  UPDATE_PATTERN_RESET,
  CREATE_PATTERN_REVIEW_REQUEST,
  CREATE_PATTERN_REVIEW_FAIL,
  CREATE_PATTERN_REVIEW_SUCCESS,
  CREATE_PATTERN_REVIEW_RESET,
} from "../actions/constants/pattern";

export const patternReducer = (
  state = { pattern: null, loading: false, success: false },
  action: any
) => {
  switch (action.type) {
    case GET_PATTERN_REQUEST:
    case CREATE_PATTERN_REQUEST:
    case REMOVE_PATTERN_REQUEST:
    case UPDATE_PATTERN_REQUEST:
      return { loading: true, pattern: null };
    case GET_PATTERN_SUCCESS:
    case CREATE_PATTERN_SUCCESS:
    case UPDATE_PATTERN_SUCCESS:
      return { pattern: action.payload, loading: false, success: true };
    case CREATE_PATTERN_FAIL:
    case GET_PATTERN_FAIL:
    case REMOVE_PATTERN_FAIL:
    case UPDATE_PATTERN_FAIL:
      return { loading: false, error: action.payload, success: false };
    case CREATE_PATTERN_RESET:
    case UPDATE_PATTERN_RESET:
      return { pattern: null };
    default:
      return state;
  }
};

export const patternListReducer = (
  state = { patterns: [], loading: false, pagination: null },
  action: any
) => {
  const { type, payload } = action;
  switch (type) {
    case GET_USERS_PATTERNS_REQUEST:
      return { ...state, loading: true, patterns: null };
    case GET_USERS_PATTERNS_SUCCESS:
      return {
        patterns: payload,
        pagination: action.pagination || null,
        loading: false,
      };
    case REMOVE_PATTERN_SUCCESS:
      return {
        ...state,
        loading: false,
        patterns: state.patterns.filter(
          (pattern: any) => pattern._id !== payload
        ),
      };
    case GET_USERS_PATTERNS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const patternReviewReducer = (state = {}, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_PATTERN_REVIEW_REQUEST:
      return { loading: true };
    case CREATE_PATTERN_REVIEW_SUCCESS:
      return {
        success: true,
        loading: false,
      };
    case CREATE_PATTERN_REVIEW_FAIL:
      return {
        loading: false,
        error: payload,
      };
    case CREATE_PATTERN_REVIEW_RESET:
      return {};
    default:
      return state;
  }
};

export const allPatternsReducer = (
  state = { patterns: [], loading: false, pagination: null, error: null },
  action: any
) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_PATTERNS_REQUEST:
      return { ...state, loading: true };
    case GET_ALL_PATTERNS_SUCCESS:
      return {
        patterns: payload,
        pagination: action.pagination,
        loading: false,
        error: null,
      };
    case GET_ALL_PATTERNS_FAIL:
      return { ...state, loading: false, error: payload };
    default:
      return state;
  }
};
